import { IdentificationIcon, PencilSquareIcon } from "@heroicons/react/24/outline";
// import UpdateHostRegistry from "../dialogContent/UpdateHostRegistry";
import ActionButtonDialogRow from "../main/ActionButtonDialogRow";
import DialogComponent from "../main/DIalogComponent";

export default function ActionUpdateRegistry({ row, label, type, elementForTab}: any) {
    return (
        <DialogComponent
            icon={ type ? <IdentificationIcon className="w-6 h-6" /> : <PencilSquareIcon className="w-6 h-6" />}
            label={label}
            // content={<UpdateHostRegistry row={row} />}
            content={<ActionButtonDialogRow elementForTab={elementForTab} />}
        />
    )
}